import { useEffect, useState, useContext } from "react";
import { useToastAction } from "../../hooks/useToastAction";
import { previewHtml } from "../../api/webEditor";
import { setApiKey } from "../../api/api";
import { MetaforceContext } from "../../contexts";
import * as Constants from "../../utils/constants";
import { useTranslation } from 'react-i18next';
import { resources, translations } from "../../translations/translationsConstants";

export const HtmlPreview = () => {
    const { startParameter } = useContext(MetaforceContext);
    const [blobUrl, setBlobUrl] = useState();
    const { t: terr } = useTranslation([resources.errors]);

    setApiKey();

    const loadAction = useToastAction();

    const loadData = async () => {
        loadAction.execute(async () => {
            const res = await previewHtml(startParameter);
            const blob = new Blob([res], { type: "text/html" });
            const newBlobUrl = URL.createObjectURL(blob);
            setBlobUrl(newBlobUrl);
        }, terr(translations.errors.failLoadFile));
    }

    useEffect(() => {
        loadData()
    }, []);

    return !loadAction.isExecuting && (
        <main className="tw-h-full tw-w-full">
            {blobUrl && <iframe width='100%' height='100%' src={blobUrl} />}
        </main>
    )
}